/** Short tick where the platform supports it. iOS Safari has no vibrate API. */
export const hapticTick = () => {
  const vibrate = navigator.vibrate;
  if (typeof vibrate !== "function") return;
  try {
    vibrate.call(navigator, [10]);
  } catch {
    // A WebView can expose vibrate and still throw. Ignore it.
  }
};
